module.exports = __webpack_public_path__ + "img/GraphicDesign.ec32c748.jpg";